import Service from "../../Services";

const Contact = {
    namespaced : true,
    state : {
        categories: []
    },
    mutations : {
        setCategories(state, data) {
            state.categories = data;
        }
    },
    actions : {
        sendMsgVenueHire({ commit }, data) {
            return Service.ContactAPI.sendMsgVenueHire(data);
        },
        sendMsgGroupVisit({ commit }, data) {
            return Service.ContactAPI.sendMsgGroupVisit(data);
        },
        sendMsgContactBranch({ commit }, data) {
            return Service.ContactAPI.sendMsgContactBranch(data);
        },
        onGetCategoryEnewsletter({ commit }) {
            return Service.ContactAPI.getCategoryEnewsletter().then(res => {
                if (res.response_code === 200) {
                    commit('setCategories', res.result);
                }
            });
        },
        onSubscribeEnewsletter({ commit }, data) {
            return Service.ContactAPI.subscribeEnewsletter(data);
        }
    }
}
export default Contact
